require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.split");

!function (a, e) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : (a.ReactIntlLocaleData = a.ReactIntlLocaleData || {}, a.ReactIntlLocaleData.gd = e());
}(this, function () {
  "use strict";

  return [{
    locale: "gd",
    pluralRuleFunction: function pluralRuleFunction(a, e) {
      var i = String(a).split("."),
          n = Number(i[0]) == a;
      return e ? 1 == a || 11 == a ? "one" : 2 == a || 12 == a ? "two" : 3 == a || 13 == a ? "few" : "other" : 1 == a || 11 == a ? "one" : 2 == a || 12 == a ? "two" : n && a >= 3 && a <= 10 || n && a >= 13 && a <= 19 ? "few" : "other";
    },
    fields: {
      year: {
        displayName: "bliadhna",
        relative: {
          0: "am bliadhna",
          1: "an ath-bhliadhna",
          "-2": "a-bhòn-uiridh",
          "-1": "an-uiridh"
        },
        relativeTime: {
          future: {
            one: "an ceann {0} bhliadhna",
            two: "an ceann {0} bhliadhna",
            few: "an ceann {0} bliadhnaichean",
            other: "an ceann {0} bliadhna"
          },
          past: {
            one: "{0} bhliadhna air ais",
            two: "{0} bhliadhna air ais",
            few: "{0} bhliadhnaichean air ais",
            other: "{0} bliadhna air ais"
          }
        }
      },
      "year-short": {
        displayName: "blia.",
        relative: {
          0: "am bliadhna",
          1: "an ath-bhliadhna",
          "-2": "a-bhòn-uiridh",
          "-1": "an-uiridh"
        },
        relativeTime: {
          future: {
            one: "an {0} bhlia.",
            two: "an {0} bhlia.",
            few: "an {0} blia.",
            other: "an {0} blia."
          },
          past: {
            one: "o {0} bhlia.",
            two: "o {0} bhlia.",
            few: "o {0} blia.",
            other: "o {0} blia."
          }
        }
      },
      month: {
        displayName: "mìos",
        relative: {
          0: "am mìos seo",
          1: "an ath-mhìos",
          "-1": "am mìos seo chaidh"
        },
        relativeTime: {
          future: {
            one: "an ceann {0} mhìosa",
            two: "an ceann {0} mhìosa",
            few: "an ceann {0} mìosan",
            other: "an ceann {0} mìosa"
          },
          past: {
            one: "{0} mhìos air ais",
            two: "{0} mhìos air ais",
            few: "{0} mìosan air ais",
            other: "{0} mìos air ais"
          }
        }
      },
      "month-short": {
        displayName: "mìos",
        relative: {
          0: "am mìos seo",
          1: "an ath-mhìos",
          "-1": "am mìos sa chaidh"
        },
        relativeTime: {
          future: {
            one: "an {0} mhìos.",
            two: "an {0} mhìos.",
            few: "an {0} mìos.",
            other: "an {0} mìos."
          },
          past: {
            one: "o {0} mhìos.",
            two: "o {0} mhìos.",
            few: "o {0} mìos.",
            other: "o {0} mìos."
          }
        }
      },
      day: {
        displayName: "latha",
        relative: {
          0: "an-diugh",
          1: "a-màireach",
          2: "an-earar",
          3: "an-eararais",
          "-2": "a-bhòin-dè",
          "-1": "an-dè"
        },
        relativeTime: {
          future: {
            one: "an ceann {0} latha",
            two: "an ceann {0} latha",
            few: "an ceann {0} làithean",
            other: "an ceann {0} latha"
          },
          past: {
            one: "{0} latha air ais",
            two: "{0} latha air ais",
            few: "{0} làithean air ais",
            other: "{0} latha air ais"
          }
        }
      },
      "day-short": {
        displayName: "là",
        relative: {
          0: "an-diugh",
          1: "a-màireach",
          2: "an-earar",
          3: "an-eararais",
          "-2": "a-bhòin-dè",
          "-1": "an-dè"
        },
        relativeTime: {
          future: {
            one: "an {0} là",
            two: "an {0} là",
            few: "an {0} là.",
            other: "an {0} là"
          },
          past: {
            one: "o {0} là",
            two: "o {0} là",
            few: "o {0} là.",
            other: "o {0} là"
          }
        }
      },
      hour: {
        displayName: "uair a thìde",
        relative: {
          0: "am broinn uair a thìde"
        },
        relativeTime: {
          future: {
            one: "an ceann {0} uair a thìde",
            two: "an ceann {0} uair a thìde",
            few: "an ceann {0} uairean a thìde",
            other: "an ceann {0} uair a thìde"
          },
          past: {
            one: "{0} uair a thìde air ais",
            two: "{0} uair a thìde air ais",
            few: "{0} uairean a thìde air ais",
            other: "{0} uair a thìde air ais"
          }
        }
      },
      "hour-short": {
        displayName: "uair",
        relative: {
          0: "am broinn uair"
        },
        relativeTime: {
          future: {
            one: "an {0} uair",
            two: "an {0} uair",
            few: "an {0} uair.",
            other: "an {0} uair"
          },
          past: {
            one: "o {0} uair",
            two: "o {0} uair",
            few: "o {0} uair.",
            other: "o {0} uair"
          }
        }
      },
      minute: {
        displayName: "mionaid",
        relative: {
          0: "am broinn mionaid"
        },
        relativeTime: {
          future: {
            one: "an ceann {0} mhionaid",
            two: "an ceann {0} mhionaid",
            few: "an ceann {0} mionaidean",
            other: "an ceann {0} mionaid"
          },
          past: {
            one: "{0} mhionaid air ais",
            two: "{0} mhionaid air ais",
            few: "{0} mionaidean air ais",
            other: "{0} mionaid air ais"
          }
        }
      },
      "minute-short": {
        displayName: "mion.",
        relative: {
          0: "am broinn mion."
        },
        relativeTime: {
          future: {
            one: "an {0} mhion.",
            two: "an {0} mhion.",
            few: "an {0} mion.",
            other: "an {0} mion."
          },
          past: {
            one: "o {0} mhion.",
            two: "o {0} mhion.",
            few: "o {0} mion.",
            other: "o {0} mion."
          }
        }
      },
      second: {
        displayName: "diog",
        relative: {
          0: "an-dràsta"
        },
        relativeTime: {
          future: {
            one: "an ceann {0} diog",
            two: "an ceann {0} dhiog",
            few: "an ceann {0} diogan",
            other: "an ceann {0} diog"
          },
          past: {
            one: "{0} diog air ais",
            two: "{0} dhiog air ais",
            few: "{0} diogan air ais",
            other: "{0} diog air ais"
          }
        }
      },
      "second-short": {
        displayName: "diog",
        relative: {
          0: "an-dràsta"
        },
        relativeTime: {
          future: {
            one: "an {0} diog",
            two: "an {0} dhiog",
            few: "an {0} diog.",
            other: "an {0} diog"
          },
          past: {
            one: "o {0} diog",
            two: "o {0} dhiog",
            few: "o {0} diog.",
            other: "o {0} diog"
          }
        }
      }
    }
  }];
});